import {Title} from "../../enums/title.enum";
import moment from "moment";

export class GdprResponseModel {
  title: Title | null;
  firstName: string | null;
  lastName: string | null;
  jobTitle: string | null;
  companyName: string | null;
  atozNewsConsent: boolean | null;
  atozEventsConsent: boolean | null;
  devecoNewsConsent: boolean | null;
  devecoEventsConsent: boolean | null;
  dotDigitalConsent: boolean;
  esgConsent: boolean;
  modifiedAt: moment.Moment;


  constructor(
    title: Title | null,
    firstName: string | null,
    lastName: string | null,
    jobTitle: string | null,
    companyName: string | null,
    atozNewsConsent: boolean | null,
    atozEventsConsent: boolean | null,
    devecoNewsConsent: boolean | null,
    devecoEventsConsent: boolean | null,
    dotDigitalConsent: boolean,
    esgConsent: boolean,
    modifiedAt: moment.Moment
  ) {
    this.title = title;
    this.firstName = firstName;
    this.lastName = lastName;
    this.jobTitle = jobTitle;
    this.companyName = companyName;
    this.atozNewsConsent = atozNewsConsent;
    this.atozEventsConsent = atozEventsConsent;
    this.devecoNewsConsent = devecoNewsConsent;
    this.devecoEventsConsent = devecoEventsConsent;
    this.dotDigitalConsent = dotDigitalConsent;
    this.esgConsent = esgConsent;
    this.modifiedAt = moment(modifiedAt);
  }
}
